import { InputLabel } from '@mui/material';
import TextField from '@mui/material/TextField';
import { useField } from 'formik';

const TextFieldWrapper = ({ name, ...otherProps }) => {
	const [field, meta] = useField(name);

	const configTextField = {
		fullWidth: true,
		variant: 'outlined',
		...field,
		// "named" props above apply to all
		// Textfields present.
		// "otherProps" below will be custom tailored
		// to particular Text/Date etc. Fields
		// such as label, type, id, etc.
		...otherProps,
	};

	// meta object containes
	// submitForm, isSubmitting, touched, errors
	if (meta && meta.touched && meta.error) {
		configTextField.error = true;
		configTextField.helperText = meta.error;
	}

	return (
		<>
			<InputLabel required={configTextField.required}>
				{configTextField.label}
			</InputLabel>
			<TextField {...configTextField} label="" />
		</>
	);
};

export default TextFieldWrapper;
